import React from 'react';
import Indicator from './indicator';
import "./indicators.scss";
import { useMediaQuery, useTheme } from '@mui/material';

export default function Indicators({filters, isHovered}: {filters: string[], isHovered: boolean}){
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const colorsPallet = [
        '#DB2C00',
        '#1D1A1A',
        '#7B726C',
        '#B3AAA3'
    ];
    const categories = ['driving', 'putting', 'irons', 'chipping', 'bunkers', 'mental-game'];

    const capitalizeEachWord = (str: string) => {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const listIndicators = filters
        .filter(filterName => filterName.startsWith('category:'))
        .map(filter => filter.replace(/^category:\s*/, ''))
        .sort((a, b) => {
            const indexA = categories.indexOf(a);
            const indexB = categories.indexOf(b);

            if (indexA === -1 && indexB !== -1) return 1;
            if (indexA !== -1 && indexB === -1) return -1;

            if (indexA !== -1 && indexB !== -1) return indexA - indexB;

            return 0;
        })
        .slice(0, isMobile ? 3 : 4)
        .map((filter, index) => (
            <Indicator
                key={index}
                color={colorsPallet[index % colorsPallet.length]}
                styleIndicator={'indicatorItem'}    
                category={capitalizeEachWord(filter.replace(/-/g, ' '))}
            />
        ));
    
    return (
        <div className={'indicatorList'} style={{display: isHovered ? 'flex' : 'none'}}>{listIndicators}</div>
    );
}